import React from 'react';
import styled from 'styled-components';
import { fridaySermons } from '../friday_sermons_data';

const PrayerContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
`;

const HeroSection = styled.section`
  background: linear-gradient(135deg, #2c5aa0 0%, #1e3a8a 100%);
  color: #fff;
  padding: 60px 0;
  text-align: center;
`;

const HeroContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 15px;
`;

const Subtitle = styled.p`
  font-size: 18px;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
`;

const ContentSection = styled.section`
  padding: 40px 0;
`;

const ContentContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const VideoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;
  margin-top: 40px;
`;

const VideoCard = styled.div`
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
  }
`;

const ThumbnailContainer = styled.div`
  position: relative;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  background: #000;
`;

const Thumbnail = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const CardContent = styled.div`
  padding: 15px;
`;

const SermonDate = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
`;

const SermonTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const VideoModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 20px;
`;

const VideoWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  aspect-ratio: 16/9;
  position: relative;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 0 30px rgba(0,0,0,0.5);
`;

const CloseButton = styled.button`
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: #fff;
  font-size: 30px;
  cursor: pointer;
  padding: 5px;
  
  &:hover {
    color: #ccc;
  }
`;

const FridayPrayer: React.FC = () => {
  const [selectedVideo, setSelectedVideo] = React.useState<string | null>(null);

  const handlePlayClick = (videoId: string) => {
    setSelectedVideo(videoId);
  };

  const closeVideo = () => {
    setSelectedVideo(null);
  };

  return (
    <PrayerContainer>
      <HeroSection>
        <HeroContent>
          <Title>금요성령기도회 설교</Title>
          <Subtitle>찬양과 기도로 하나님께 나아가는 복된 시간</Subtitle>
        </HeroContent>
      </HeroSection>

      <ContentSection>
        <ContentContainer>
          <VideoGrid>
            {fridaySermons.map((sermon, index) => (
              <VideoCard key={index} onClick={() => handlePlayClick(sermon.videoId)}>
                <ThumbnailContainer>
                  <Thumbnail
                    src={`https://img.youtube.com/vi/${sermon.videoId}/mqdefault.jpg`}
                    alt={sermon.title}
                    loading="lazy"
                  />
                </ThumbnailContainer>
                <CardContent>
                  <SermonDate>{sermon.date}</SermonDate>
                  <SermonTitle>{sermon.title}</SermonTitle>
                </CardContent>
              </VideoCard>
            ))}
          </VideoGrid>
        </ContentContainer>
      </ContentSection>

      {selectedVideo && (
        <VideoModal onClick={closeVideo}>
          <div style={{ position: 'relative', width: '100%', maxWidth: '1000px' }} onClick={e => e.stopPropagation()}>
            <CloseButton onClick={closeVideo}>&times;</CloseButton>
            <VideoWrapper>
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${selectedVideo}?autoplay=1`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </VideoWrapper>
          </div>
        </VideoModal>
      )}
    </PrayerContainer>
  );
};

export default FridayPrayer;


